import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from './../components/api'
import { Link } from 'react-router-dom'
//import { useTabelaGestao } from '../context/GestaoPendenciasContext'
import moment from 'moment'

import { useEnunciadoContext } from '../context/enunciadoContext'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../components/StatusValidacaoSecao'


const SaudePeloClima_Resiliencia = (props) => {


    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id
    var formulario_id = props.formulario_id


    //var { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()


    var [resilencia_analisouRiscos, setResilencia_analisouRiscos] = useState()
    var [resilencia_revisouEvidencias, setResiliencia_revisouEvidencias] = useState()
    var [resilencia_elaborouRelatorio, setResilencia_elaborouRelatorio] = useState()
    var [resiliencia_atividades, setResiliencia_atividades] = useState('')
    var [resilencia_analisouPotencial, setResiliencia_analisouPotencial] = useState()

    var [resiliencia_analiseVulnerabilidades, setResiliencia_analiseVulnerabilidades] = useState('')
    var [resiliencia_planoVulnerabilidades, setResiliencia_planoVulnerabilidades] = useState('')
    var [resiliencia_implementouMelhorias, setResiliencia_implementouMelhorias] = useState('')
    var [resiliencia_analiseVulnerabilidadesDescricao, setResiliencia_analiseVulnerabilidadesDescricao] = useState('')
    var [resiliencia_avaliouImpactos, setResiliencia_avaliouImpactos] = useState('')
    var [resiliencia_desenvolveuPlano, setResiliencia_desenvolveuPlano] = useState('')
    var [resiliencia_aprimorouPlano, setResiliencia_aprimorouPlano] = useState('')
    var [resiliencia_avaliouImpactosDescricao, setResiliencia_avaliouImpactosDescricao] = useState('')
    var [resiliencia_planoPandemia, setResiliencia_planoPandemia] = useState('')
    var [resiliencia_planoPandemiaDescricao, setResiliencia_planoPandemiaDescricao] = useState('')
    var [resiliencia_pegadaClimaticaRenovavel, setResiliencia_pegadaClimaticaRenovavel] = useState()
    var [resiliencia_pegadaClimaticaEficiencia, setResiliencia_pegadaClimaticaEficiencia] = useState()
    var [resiliencia_pegadaClimaticaCogeracao, setResiliencia_pegadaClimaticaCogeracao] = useState()
    var [resiliencia_pegadaClimaticaSolar, setResiliencia_pegadaClimaticaSolar] = useState()
    var [resiliencia_pegadaClimaticaAquecer, setResiliencia_pegadaClimaticaAquecer] = useState()
    var [resiliencia_pegadaClimaticaOutros, setResiliencia_pegadaClimaticaOutros] = useState()
    var [resiliencia_pegadaClimaticaNenhuma, setResiliencia_pegadaClimaticaNenhuma] = useState()
    var [resiliencia_pegadaClimaticaDescricao, setResiliencia_pegadaClimaticaDescricao] = useState('')

    var [resiliencia_colaborouProgramas, setResiliencia_colaborouProgramas] = useState('')
    var [resiliencia_colaborouProgramasDescricao, setResiliencia_colaborouProgramasDescricao] = useState('')

    var [resiliencia_ecoPropriedades, setResiliencia_ecoPropriedades] = useState()
    var [resiliencia_ecoComunidade, setResiliencia_ecoComunidade] = useState()
    var [resiliencia_ecoNao, setResiliencia_ecoNao] = useState()
    var [resiliencia_ecoDescricao, setResiliencia_ecoDescricao] = useState('')
    var [resiliencia_informacoesAdicionais, setResiliencia_informacoesAdicionais] = useState('')


    const [questao1, setQuestao1] = useState()
    const [questao2, setQuestao2] = useState()

    const [questao3, setQuestao3] = useState()
    const [questao4, setQuestao4] = useState()
    const [questao5, setQuestao5] = useState()
    const [questao6, setQuestao6] = useState()
    const [questao7, setQuestao7] = useState()
    const [questao8, setQuestao8] = useState()
    const [questao9, setQuestao9] = useState()
    const [questao10, setQuestao10] = useState()
    const [questao11, setQuestao11] = useState()
    const [questao12, setQuestao12] = useState()

    const [totalPendencias, setTotalPendencias] = useState(0)


    async function carregaAcoesResiliencia() {


        await api.get(`desafioClimaAcoes/${adesao_institucional_id}/${ano}`).then((result) => {

            //console.log(result.data)

            /*
            economica_atividades: "ddd"
            economica_carvao: "N"
            economica_energiaLimpa: "A"
            economica_fosseis: "S"
            iniciativasLideranca: "eeefg"
            lideranca_atividades: "bbb"
            lideranca_comunidade: false
            lideranca_funcionarios: true
            lideranca_medicos: true
            lideranca_pacientes: false
            politica_acesso: true
            politica_adaptacaoSetor: false
            politica_reducaoEmissao: false
            politica_transicaoCombustiveis: true
            resilencia_analisouPotencial: "S"
            resilencia_analisouRiscos: "S"
            resilencia_elaborouRelatorio: "I"
            resilencia_revisouEvidencias: "N"
            resiliencia_atividades: "aaa"
            */

            var data = result.data[0]

            //console.log(data.economica_atividades)

            setHospClima_id(data.hospClima_id)

            setResiliencia_analisouPotencial(data.resilencia_analisouPotencial)
            setResiliencia_revisouEvidencias(data.resilencia_revisouEvidencias)
            setResiliencia_atividades(data.resiliencia_atividades)
            setResilencia_analisouRiscos(data.resilencia_analisouRiscos)
            setResilencia_elaborouRelatorio(data.resilencia_elaborouRelatorio)

            setResiliencia_analiseVulnerabilidades(data.resiliencia_analiseVulnerabilidades)
            setResiliencia_planoVulnerabilidades(data.resiliencia_planoVulnerabilidades)
            setResiliencia_implementouMelhorias(data.resiliencia_implementouMelhorias)
            setResiliencia_analiseVulnerabilidadesDescricao(data.resiliencia_analiseVulnerabilidadesDescricao)
            setResiliencia_avaliouImpactos(data.resiliencia_avaliouImpactos)
            setResiliencia_desenvolveuPlano(data.resiliencia_desenvolveuPlano)
            setResiliencia_aprimorouPlano(data.resiliencia_aprimorouPlano)
            setResiliencia_avaliouImpactosDescricao(data.resiliencia_avaliouImpactosDescricao)
            setResiliencia_planoPandemia(data.resiliencia_planoPandemia)
            setResiliencia_planoPandemiaDescricao(data.resiliencia_planoPandemiaDescricao)
            setResiliencia_pegadaClimaticaRenovavel(data.resiliencia_pegadaClimaticaRenovavel)
            setResiliencia_pegadaClimaticaEficiencia(data.resiliencia_pegadaClimaticaEficiencia)
            setResiliencia_pegadaClimaticaCogeracao(data.resiliencia_pegadaClimaticaCogeracao)
            setResiliencia_pegadaClimaticaSolar(data.resiliencia_pegadaClimaticaSolar)
            setResiliencia_pegadaClimaticaAquecer(data.resiliencia_pegadaClimaticaAquecer)
            setResiliencia_pegadaClimaticaOutros(data.resiliencia_pegadaClimaticaOutros)
            setResiliencia_pegadaClimaticaNenhuma(data.resiliencia_pegadaClimaticaNenhuma)
            setResiliencia_pegadaClimaticaDescricao(data.resiliencia_pegadaClimaticaDescricao)

            setResiliencia_colaborouProgramas(data.resiliencia_colaborouProgramas)
            setResiliencia_colaborouProgramasDescricao(data.resiliencia_colaborouProgramasDescricao)

            setResiliencia_ecoPropriedades(data.resiliencia_ecoPropriedades)
            setResiliencia_ecoComunidade(data.resiliencia_ecoComunidade)
            setResiliencia_ecoNao(data.resiliencia_ecoNao)
            setResiliencia_ecoDescricao(data.resiliencia_ecoDescricao)
            setResiliencia_informacoesAdicionais(data.resiliencia_informacoesAdicionais)



        }).catch((err) => {

            console.log(err.response)

        })


    }


    useEffect(() => {


        setHospClima_id()

        setResiliencia_analisouPotencial()
        setResiliencia_revisouEvidencias()
        setResiliencia_atividades('')
        setResilencia_analisouRiscos()
        setResilencia_elaborouRelatorio()


        setResiliencia_analiseVulnerabilidades('')
        setResiliencia_planoVulnerabilidades('')
        setResiliencia_implementouMelhorias('')
        setResiliencia_analiseVulnerabilidadesDescricao('')
        setResiliencia_avaliouImpactos('')
        setResiliencia_desenvolveuPlano('')
        setResiliencia_aprimorouPlano('')
        setResiliencia_avaliouImpactosDescricao('')
        setResiliencia_planoPandemia('')
        setResiliencia_planoPandemiaDescricao('')
        setResiliencia_pegadaClimaticaRenovavel()
        setResiliencia_pegadaClimaticaEficiencia()
        setResiliencia_pegadaClimaticaCogeracao()
        setResiliencia_pegadaClimaticaSolar()
        setResiliencia_pegadaClimaticaAquecer()
        setResiliencia_pegadaClimaticaOutros()
        setResiliencia_pegadaClimaticaNenhuma()
        setResiliencia_pegadaClimaticaDescricao('')

        setResiliencia_colaborouProgramas('')
        setResiliencia_colaborouProgramasDescricao('')

        setResiliencia_ecoPropriedades()
        setResiliencia_ecoComunidade()
        setResiliencia_ecoNao()
        setResiliencia_ecoDescricao('')
        setResiliencia_informacoesAdicionais('')

        setQuestao1('')
        setQuestao2('')

        setQuestao3('')
        setQuestao4('')
        setQuestao5('')
        setQuestao6('')
        setQuestao7('')
        setQuestao8('')
        setQuestao9('')
        setQuestao10('')
        setQuestao11('')
        setQuestao12('')



        if (ano) {

            carregaAcoesResiliencia()

        }



    }, [ano, adesao_institucional_id])



    useEffect(() => {

        verificaValidacoes()

    }, [hospClima_id, verificaDesafio, formulario_id])


    const verificaValidacoes = () => {



        setQuestao1()
        setQuestao2()

        setQuestao3('')
        setQuestao4('')
        setQuestao5('')
        setQuestao6('')
        setQuestao7('')
        setQuestao8('')
        setQuestao9('')
        setQuestao10('')
        setQuestao11('')
        setQuestao12('')



        if (hospClima_id) {

            var dataPost = {

                formulario_id: hospClima_id,
                desafio: 'Clima',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {


                var data = result.data
                //console.log(data)

                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            /*

                            case 'Análise dos riscos de eventos climáticos extremos e vulnerabilidades da assistência à saúde devido às mudanças do clima*':

                                setQuestao1('red')

                                break

                            case 'Utilize o campo abaixo para fornecer informações adicionais sobre as iniciativas de resiliência climática como, por exemplo:':

                                setQuestao2('red')

                                break

                            */

                             case 'Análise dos riscos de eventos climáticos extremos e vulnerabilidades da assistência à saúde devido às mudanças do clima*':

                                setQuestao1('red')
                                totalErros = totalErros + 1
                                

                            break

                            case 'A sua instituição realizou uma análise de vulnerabilidade e/ou um relatório de avaliação de múltiplos riscos sobre as vulnerabilidades do seu edifício e infraestrutura aos impactos das alterações climáticas, incluindo eventos climáticos extremos, e formas de os abordar?':

                                setQuestao2('red')
                                totalErros = totalErros + 1
                                

                            break

                            case '1a. Sua instituição desenvolveu um plano para atender as vulnerabilidades do seu edifício com base em análise de risco e a evolução de ameaças?':

                                setQuestao3('red')
                                totalErros = totalErros + 1
                                

                            break

                            case '1b. A sua instituição implementou melhorias nos seus edifícios e infraestruturas como resultado da análise de riscos e avaliação de ameaças?':

                                setQuestao4('red')
                                totalErros = totalErros + 1
                                

                            break

                            case 'Sua instituição avaliou os impactos das alterações climáticas nos serviços de saúde e nas necessidades de prestação de cuidados de saúde resultantes das alterações climáticas?':

                                setQuestao5('red')
                                totalErros = totalErros + 1
                                

                            break

                            case '2a. A sua instituição desenvolveu um plano para responder às necessidades de prestação de cuidados de saúde decorrentes das alterações climáticas?':

                                setQuestao6('red')
                                totalErros = totalErros + 1
                                

                            break

                            case '2b. A sua instituição aprimorou o plano desenvolvido para responder às necessidades de prestação de cuidados de saúde decorrentes das alterações climáticas?':

                                setQuestao7('red')
                                totalErros = totalErros + 1
                                

                            break

                            case 'A sua instituição desenvolveu/implementou planos sobre como estar preparada para responder a uma pandemia?':

                                setQuestao8('red')
                                totalErros = totalErros + 1
                                

                            break

                            case 'A sua instituição implementou soluções para promover a resiliência e simultaneamente reduzir a pegada climática? Selecione as seguintes opções conforme apropriado.':

                                setQuestao9('red')
                                totalErros = totalErros + 1
                                

                            break

                            case 'A sua instituição desenvolveu ou colaborou em programas/iniciativas com organizações comunitárias locais ou agências governamentais que se concentram na melhoria da resiliência?':

                                setQuestao10('red')
                                totalErros = totalErros + 1
                                

                            break

                            case 'A sua instituição participou em atividades para restaurar e melhorar os serviços ecossistêmicos com o objetivo de fortalecer a resiliência da comunidade?':

                                setQuestao11('red')
                                totalErros = totalErros + 1
                                

                            break

                            case 'Utilize o campo abaixo para fornecer informações adicionais sobre as iniciativas de resiliência climática como, por exemplo:':

                                setQuestao12('red')
                                totalErros = totalErros + 1
                                

                            break
                        }

                    }


                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    var [hospClima_id, setHospClima_id] = useState()

    return (

        <div>

            <div className="row">

                <div className="col-md-12">

                    As informações com (*) são de preenchimento obrigatório
                    <br /><br /><br />

                    <b>RESILIÊNCIA</b>

                    <br /><br />



                </div>

                <div className="col-md-12">


                    <Table striped bordered hover>

                        <tbody>
                            <tr style={{ display: 'none'}}>
                                <td style={{ backgroundColor: '#e6f7ec' }} >
                                <Link to='#' style={{ color: questao1 }} onClick={() => {setEnunciado('Análise dos riscos de eventos climáticos extremos e vulnerabilidades da assistência à saúde devido às mudanças do clima*');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    Análise dos riscos de eventos climáticos extremos e vulnerabilidades da assistência à saúde devido às mudanças do clima*
                                </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Iniciado, mas não concluido
                                    </center>
                                </td>
                            </tr>
                            <tr  style={{ display: 'none'}}>
                                <td>
                                    Sua instituição analisou os riscos de desastres locais devido a mudança do clima e seu papel como unidade ou sistema de saúde para enfrentá-los?
                                    

                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_analisouRiscos" onClick={() => setResilencia_analisouRiscos('S')} checked={resilencia_analisouRiscos == 'S' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_analisouRiscos" onClick={() => setResilencia_analisouRiscos('N')} checked={resilencia_analisouRiscos == 'N' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_analisouRiscos" onClick={() => setResilencia_analisouRiscos('I')} checked={resilencia_analisouRiscos == 'I' ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>


                            <tr  style={{ display: 'none'}}>
                                <td>
                                    Sua instituição revisou evidências de riscos à saúde devidos às mudanças do clima (a partir de dados locais de saúde pública, avaliações epidemiológicas e de vulnerabilidade, p.ex.: alteração geográfica de doenças causadas por vetores, ondas de calor extremo, etc.) que possam atingir sua comunidade?

                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_revisouEvidencias" onClick={() => setResiliencia_revisouEvidencias('S')} checked={resilencia_revisouEvidencias == 'S' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_revisouEvidencias" onClick={() => setResiliencia_revisouEvidencias('N')} checked={resilencia_revisouEvidencias == 'N' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_revisouEvidencias" onClick={() => setResiliencia_revisouEvidencias('I')} checked={resilencia_revisouEvidencias == 'I' ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>


                            <tr  style={{ display: 'none'}}>
                                <td>
                                    Sua instituição elaborou algum Relatório de Análise de Riscos sobre a vulnerabilidade da sua edificação e infraestrutura à eventos climáticos extremos e como lidar com eles?
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_elaborouRelatorio" onClick={() => setResilencia_elaborouRelatorio('S')} checked={resilencia_elaborouRelatorio == 'S' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_elaborouRelatorio" onClick={() => setResilencia_elaborouRelatorio('N')} checked={resilencia_elaborouRelatorio == 'N' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_elaborouRelatorio" onClick={() => setResilencia_elaborouRelatorio('I')} checked={resilencia_elaborouRelatorio == 'I' ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>


                            <tr  style={{ display: 'none'}}>
                                <td>
                                    Sua instituição analisou o potencial para gerar resiliência e simultaneamente reduzir sua pegada de carbono (p.ex.: instalar fontes de energia renováveis fora da rede e/ou combinar aquecimento e energia)?
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_analisouPotencial" onClick={() => setResiliencia_analisouPotencial('S')} checked={resilencia_analisouPotencial == 'S' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_analisouPotencial" onClick={() => setResiliencia_analisouPotencial('N')} checked={resilencia_analisouPotencial == 'N' ? 1 : 0} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resilencia_analisouPotencial" onClick={() => setResiliencia_analisouPotencial('I')} checked={resilencia_analisouPotencial == 'I' ? 1 : 0} disabled />
                                    </center>
                                </td>
                            </tr>

                            <tr  style={{ display: 'none'}}>
                                <td colspan="4">
                                    <br />
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} rowspan="2">
                                    <Link to='#' style={{ color: questao2 }} onClick={() => {setEnunciado('A sua instituição realizou uma análise de vulnerabilidade e/ou um relatório de avaliação de múltiplos riscos sobre as vulnerabilidades do seu edifício e infraestrutura aos impactos das alterações climáticas, incluindo eventos climáticos extremos, e formas de os abordar?');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição realizou uma análise de vulnerabilidade e/ou um relatório de avaliação de múltiplos riscos de suas instalações referente aos impactos das alterações climáticas, incluindo eventos climáticos extremos e formas de os abordar?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Iniciado, mas não concluido
                                    </center>
                                </td>
                             </tr>
                             <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_analiseVulnerabilidades" onClick={() => setResiliencia_analiseVulnerabilidades('S')} checked={resiliencia_analiseVulnerabilidades == 'S' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_analiseVulnerabilidades" onClick={() => setResiliencia_analiseVulnerabilidades('N')} checked={resiliencia_analiseVulnerabilidades == 'N' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_analiseVulnerabilidades" onClick={() => setResiliencia_analiseVulnerabilidades('I')} checked={resiliencia_analiseVulnerabilidades == 'I' ? true : false} disabled />
                                    </center>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4">
                                    <br />
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} rowspan="2">
                                    <Link to='#' style={{ color: questao3 }} onClick={() => {setEnunciado('1a. Sua instituição desenvolveu um plano para atender as vulnerabilidades do seu edifício com base em análise de risco e a evolução de ameaças?');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    1a. Sua instituição desenvolveu um plano para atender as vulnerabilidades do suas instalações com base em análise de risco e a evolução de ameaças?
                                    </Link>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Iniciado, mas não concluido
                                    </center>
                                </td>
                             </tr>
                             <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_planoVulnerabilidades" onClick={() => setResiliencia_planoVulnerabilidades('S')} checked={resiliencia_planoVulnerabilidades == 'S' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_planoVulnerabilidades" onClick={() => setResiliencia_planoVulnerabilidades('N')} checked={resiliencia_planoVulnerabilidades == 'N' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_planoVulnerabilidades" onClick={() => setResiliencia_planoVulnerabilidades('I')} checked={resiliencia_planoVulnerabilidades == 'I' ? true : false} disabled />
                                    </center>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4">
                                    <br />
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} rowspan="2">
                                    <Link to='#' style={{ color: questao4 }} onClick={() => {setEnunciado('1b. A sua instituição implementou melhorias nos seus edifícios e infraestruturas como resultado da análise de riscos e avaliação de ameaças?');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    1b. A sua instituição implementou melhorias nas suas instalações como resultado da análise de riscos e avaliação de ameaças?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Iniciado, mas não concluido
                                    </center>
                                </td>
                             </tr>
                             <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_implementouMelhorias" onClick={() => setResiliencia_implementouMelhorias('S')} checked={resiliencia_implementouMelhorias == 'S' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_implementouMelhorias" onClick={() => setResiliencia_implementouMelhorias('N')} checked={resiliencia_implementouMelhorias == 'N' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_implementouMelhorias" onClick={() => setResiliencia_implementouMelhorias('I')} checked={resiliencia_implementouMelhorias == 'I' ? true : false} disabled />
                                    </center>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4">
                                    <br />
                                    Por favor, descreva:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} value={resiliencia_analiseVulnerabilidadesDescricao} onChange={event => setResiliencia_analiseVulnerabilidadesDescricao(event.target.value)} placeholder="Aqui..." disabled />
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4">
                                    <br />
                                </td>
                            </tr>


                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} rowspan="2">
                                    <Link to='#' style={{ color: questao5 }} onClick={() => {setEnunciado('Sua instituição avaliou os impactos das alterações climáticas nos serviços de saúde e nas necessidades de prestação de cuidados de saúde resultantes das alterações climáticas?');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    Sua instituição avaliou os impactos das alterações climáticas nos serviços de saúde e nas necessidades de prestação de cuidados de saúde resultantes das alterações climáticas? (por exemplo, migração de doenças transmitidas por vetores, ondas de frio ou fortes, furacões, secas, etc.)
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Iniciado, mas não concluido
                                    </center>
                                </td>
                             </tr>
                             <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_avaliouImpactos" onClick={() => setResiliencia_avaliouImpactos('S')} checked={resiliencia_avaliouImpactos == 'S' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_avaliouImpactos" onClick={() => setResiliencia_avaliouImpactos('N')} checked={resiliencia_avaliouImpactos == 'N' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_avaliouImpactos" onClick={() => setResiliencia_avaliouImpactos('I')} checked={resiliencia_avaliouImpactos == 'I' ? true : false} disabled />
                                    </center>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4">
                                    <br />
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} rowspan="2" >
                                <Link to='#' style={{ color: questao6 }} onClick={() => {setEnunciado('2a. A sua instituição desenvolveu um plano para responder às necessidades de prestação de cuidados de saúde decorrentes das alterações climáticas?');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    2a. A sua instituição desenvolveu um plano para responder às necessidades de prestação de cuidados de saúde decorrentes das alterações climáticas?
                                </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Iniciado, mas não concluido
                                    </center>
                                </td>
                             </tr>
                             <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_desenvolveuPlano" onClick={() => setResiliencia_desenvolveuPlano('S')} checked={resiliencia_desenvolveuPlano == 'S' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_desenvolveuPlano" onClick={() => setResiliencia_desenvolveuPlano('N')} checked={resiliencia_desenvolveuPlano == 'N' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_desenvolveuPlano" onClick={() => setResiliencia_desenvolveuPlano('I')} checked={resiliencia_desenvolveuPlano == 'I' ? true : false} disabled />
                                    </center>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4">
                                    <br />
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} rowspan="2">
                                <Link to='#' style={{ color: questao7 }} onClick={() => {setEnunciado('2b. A sua instituição aprimorou o plano desenvolvido para responder às necessidades de prestação de cuidados de saúde decorrentes das alterações climáticas?');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    2b. A sua instituição aprimorou o plano desenvolvido para responder às necessidades de prestação de cuidados de saúde decorrentes das alterações climáticas?
                                </Link>

                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Iniciado, mas não concluido
                                    </center>
                                </td>
                             </tr>
                             <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_aprimorouPlano" onClick={() => setResiliencia_aprimorouPlano('S')} checked={resiliencia_aprimorouPlano == 'S' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_aprimorouPlano" onClick={() => setResiliencia_aprimorouPlano('N')} checked={resiliencia_aprimorouPlano == 'N' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_aprimorouPlano" onClick={() => setResiliencia_aprimorouPlano('I')} checked={resiliencia_aprimorouPlano == 'I' ? true : false} disabled />
                                    </center>
                                </td>
                            </tr>



                            <tr>
                                <td colspan="4">
                                    <br />
                                    Por favor, descreva:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} value={resiliencia_avaliouImpactosDescricao} onChange={event => setResiliencia_avaliouImpactosDescricao(event.target.value)} placeholder="Aqui..." disabled />
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4">
                                    <br />
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} rowspan="2">
                                    <Link to='#' style={{ color: questao8 }} onClick={() => {setEnunciado('A sua instituição desenvolveu/implementou planos sobre como estar preparada para responder a uma pandemia?');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição desenvolveu/implementou planos sobre como estar preparada para responder a uma pandemia?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Não
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }}>
                                    <center>
                                        Iniciado, mas não concluido
                                    </center>
                                </td>
                             </tr>
                             <tr>

                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_planoPandemia" onClick={() => setResiliencia_planoPandemia('S')} checked={resiliencia_planoPandemia == 'S' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_planoPandemia" onClick={() => setResiliencia_planoPandemia('N')} checked={resiliencia_planoPandemia == 'N' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input type="radio" name="resiliencia_planoPandemia" onClick={() => setResiliencia_planoPandemia('I')} checked={resiliencia_planoPandemia == 'I' ? true : false} disabled />
                                    </center>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4">
                                    <br />
                                    Por favor, descreva:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} value={resiliencia_planoPandemiaDescricao} onChange={event => setResiliencia_planoPandemiaDescricao(event.target.value)} placeholder="Aqui..." disabled />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <br />
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec', colspan: "4" }} colspan="4">
                                    <Link to='#' style={{ color: questao9 }} onClick={() => {setEnunciado('A sua instituição implementou soluções para promover a resiliência e simultaneamente reduzir a pegada climática? Selecione as seguintes opções conforme apropriado.');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição implementou soluções para promover a resiliência e simultaneamente reduzir a pegada climática? Selecione as seguintes opções conforme apropriado.
                                    </Link>
                                </td>
                            </tr>
                            
                            <tr>
                                <td colspan="3">Energia renovável sem ligação à rede elétrica</td>
                                <td colspan="1">
                                    <center>
                                        <input type="checkbox" onChange={() => setResiliencia_pegadaClimaticaRenovavel(prev => !prev)} checked={resiliencia_pegadaClimaticaRenovavel} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">Melhorias na eficiência energética</td>
                                <td colspan="1">
                                    <center>
                                        <input type="checkbox" onChange={() => setResiliencia_pegadaClimaticaEficiencia(prev => !prev)} checked={resiliencia_pegadaClimaticaEficiencia} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">Cogeração de energia elétrica e térmica</td>
                                <td colspan="1">
                                    <center>
                                        <input type="checkbox" onChange={() => setResiliencia_pegadaClimaticaCogeracao(prev => !prev)} checked={resiliencia_pegadaClimaticaEficiencia} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">Projeto de energia solar passiva (utilizar o design do edifício para climatização)</td>
                                <td colspan="1">
                                    <center>
                                        <input type="checkbox" onChange={() => setResiliencia_pegadaClimaticaSolar(prev => !prev)} checked={resiliencia_pegadaClimaticaSolar} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr style={{ display: 'none'}}>
                                <td colspan="3">Para aquecer</td>
                                <td colspan="1">
                                    <center>
                                        <input type="checkbox" onChange={() => setResiliencia_pegadaClimaticaAquecer(prev => !prev)} checked={resiliencia_pegadaClimaticaAquecer} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">Outros</td>
                                <td colspan="1">
                                    <center>
                                        <input type="checkbox" onChange={() => setResiliencia_pegadaClimaticaOutros(prev => !prev)} checked={resiliencia_pegadaClimaticaOutros} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">Nenhuma das acima</td>
                                <td colspan="1">
                                    <center>
                                        <input type="checkbox" onChange={() => setResiliencia_pegadaClimaticaNenhuma(prev => !prev)} checked={resiliencia_pegadaClimaticaNenhuma} disabled />
                                    </center>
                                </td>
                            </tr>



                            <tr>
                                <td colspan="4">
                                    <br />
                                    Por favor, descreva:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} value={resiliencia_pegadaClimaticaDescricao} onChange={event => setResiliencia_pegadaClimaticaDescricao(event.target.value)} placeholder="Aqui..." disabled />
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4" style={{ backgroundColor: '#FFF' }}>
                                    <br />
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec' }} rowspan="2" colspan="2">
                                    <Link to='#' style={{ color: questao10 }} onClick={() => {setEnunciado('A sua instituição desenvolveu ou colaborou em programas/iniciativas com organizações comunitárias locais ou agências governamentais que se concentram na melhoria da resiliência?');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição desenvolveu ou colaborou em programas/iniciativas com organizações comunitárias locais ou agências governamentais que se concentram na melhoria da resiliência?
                                    </Link>
                                    
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }} colspan="1">
                                    <center>
                                        Sim
                                    </center>
                                </td>
                                <td style={{ backgroundColor: '#e6f7ec', width: '120px' }} colspan="1">
                                    <center>
                                        Não
                                    </center>
                                </td>
                            </tr>

                            <tr>

                                <td>
                                    <center>
                                        <input colspan="1" type="radio" name="resiliencia_colaborouProgramas" onClick={() => setResiliencia_colaborouProgramas('S')} checked={resiliencia_colaborouProgramas == 'S' ? true : false} disabled />
                                    </center>
                                </td>
                                <td>
                                    <center>
                                        <input colspan="1" type="radio" name="resiliencia_colaborouProgramas" onClick={() => setResiliencia_colaborouProgramas('N')} checked={resiliencia_colaborouProgramas == 'N' ? true : false} disabled />
                                    </center>
                                </td>

                            </tr>


                            <tr>
                                <td colspan="4">
                                    <br />
                                    Por favor, descreva:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} value={resiliencia_colaborouProgramasDescricao} onChange={event => setResiliencia_colaborouProgramasDescricao(event.target.value)} placeholder="Aqui..." disabled />
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4">
                                    <br />
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: '#e6f7ec', colspan: "4" }} colspan="4">
                                    <Link to='#' style={{ color: questao11 }} onClick={() => {setEnunciado('A sua instituição participou em atividades para restaurar e melhorar os serviços ecossistêmicos com o objetivo de fortalecer a resiliência da comunidade? Por exemplo, conservação do solo, reflorestamento, proteção de rios e corpos d’água locais, etc.');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                                    A sua instituição participou em atividades para restaurar e melhorar os serviços ecossistêmicos com o objetivo de fortalecer a resiliência da comunidade? Por exemplo, conservação do solo, reflorestamento, proteção de rios e corpos d’água locais, etc.
                                    </Link>
                                    
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">Sim, dentro ou ao redor de nossas propriedades</td>
                                <td colspan="1">
                                    <center>
                                        <input type="checkbox" onChange={() => setResiliencia_ecoPropriedades(prev => !prev)} checked={resiliencia_ecoPropriedades} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">Sim, em nossa comunidade</td>
                                <td colspan="1">
                                    <center>
                                        <input type="checkbox" onChange={() => setResiliencia_ecoComunidade(prev => !prev)} checked={resiliencia_ecoComunidade} disabled />
                                    </center>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">Não</td>
                                <td colspan="1">
                                    <center>
                                        <input type="checkbox" onChange={() => setResiliencia_ecoNao(prev => !prev)} checked={resiliencia_ecoNao} disabled />
                                    </center>
                                </td>
                            </tr>

                            <tr>
                                <td colspan="4">
                                    <br />
                                    Por favor, descreva:
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <textarea className="form-control" rows="5" maxLength={1000} value={resiliencia_ecoDescricao} onChange={event => setResiliencia_ecoDescricao(event.target.value)} placeholder="Aqui..." disabled />
                                </td>
                            </tr>
                        </tbody>



                    </Table>


                </div>

                <div className="col-md-12">

                    <br />
                    <Link to='#' style={{ color: questao12 }} onClick={() => {setEnunciado('Utilize o campo abaixo para fornecer informações adicionais sobre as iniciativas de resiliência climática como, por exemplo:');setSecaoEnunciado('Resiliência');window.$('#modalValidacao').modal('show')}}>
                    <b>Utilize o campo abaixo para fornecer informações adicionais sobre as iniciativas de resiliência climática como, por exemplo:</b>
                    </Link>
                    

                    <br /><br />
                    <ul>
                        <li>* Uso de energia renovável</li>
                        <li>* Uso de fonte alternativa de água</li>
                        <li>* Desenvolvimento de projetos de eficiência energética</li>
                        <li>* Redução do consumo de energia da rede elétrica</li>
                    </ul>


                    <textarea className="form-control" rows="5" maxLength={1000} value={resiliencia_atividades} onChange={event => setResiliencia_atividades(event.target.value)} placeholder="Descreva aqui..." disabled />


                </div>

            </div>

            
            <StatusValidacaoSecao desafio="Clima" secaoCampo="secaoResiliencia" totalPendencias={totalPendencias} nomeDesafio="Desafio Clima" formulario_id={formulario_id} secao="Resiliência" adesao_institucional_id={adesao_institucional_id} ano={ano} />

        </div>

    )

}

export default SaudePeloClima_Resiliencia